import React from 'react'

import { AssetPreload } from './components'
import { QuizQuestionContext, useQuizQuestionContextValue } from './contextAPI'
import { QuizQuestionBase } from './QuizQuestion'

export const QuizQuestion: React.FC = () => {
  const quizQuestionContextValue = useQuizQuestionContextValue()

  return (
    <QuizQuestionContext.Provider value={quizQuestionContextValue}>
      <AssetPreload>
        <QuizQuestionBase />
      </AssetPreload>
    </QuizQuestionContext.Provider>
  )
}
